import type { PublicRuntimeConfigPayload } from './types'
import { requestCustomerAuthJson } from './core'

export const fetchPublicRuntimeConfig = () =>
  requestCustomerAuthJson<PublicRuntimeConfigPayload>('/public/runtime-config', {
    method: 'GET',
  })
